<template>
    <modal id="field-inspection-notification-modal">
        <template slot="body">
            <div class="information">

                <p v-if="form.notification_email">A Field Inspection email notification will be sent to the following:</p>
                <p class="text-danger" v-else>The Field Inspection will be marked as notified only.</p>

                <ul class="list-group" v-if="form.notification_email">
                    <li class="list-group-item" v-if="field_inspection.employer">
                        <b v-text="field_inspection.employer.name"></b><br>
                        <span class="text-muted" v-text="field_inspection.employer.email"></span>
                    </li>
                    <li class="list-group-item" v-if="!samePerson">
                        <b v-text="field_inspection.technician.name"></b><br>
                        <span class="text-muted" v-text="field_inspection.technician.email"></span>
                    </li>
                    <li class="list-group-item">
                        <b v-text="field_inspection.inspector.name"></b><br>
                        <span class="text-muted" v-text="field_inspection.inspector.email"></span><br>
                    </li>
                </ul>
                <div class="mt-5">
                    <field-checkbox v-model="form.notification_email" placeholder="Send notification email."></field-checkbox>
                </div>
            </div>
        </template>
        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal('field-inspection-notification-modal')">
                Cancel
            </button>
            <button class="btn btn-success" @click="save()" :disabled="form.isSubmitted">
                <span v-if="!form.isSubmitted">Send</span>
                <span v-else><i class="fa fa-spin fa-spinner"></i> Sending...</span>
            </button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                field_inspection: this.value,
                form: new Form({
                    notification_email: true,
                    notified_at: moment().format('Y-MM-DD H:mm:ss'),
                    timezone: clientTimeZone,
                })
            }
        },

        watch:{
            value(val){
                this.field_inspection = val;
            }
        },

        methods: {
            save() {
                this.form.patch(`/field-inspections/${this.field_inspection.number}`).then(response => {
                    this.closeModal('field-inspection-notification-modal');
                    this.$emit('input', response)
                    this.refreshPage();
                });
            }
        },

        computed: {
            samePerson() {
                return this.field_inspection.employer && (this.field_inspection.employer.id == this.field_inspection.technician.id);
            }
        }

    }
</script>
